export var UserTypePM;
(function (UserTypePM) {
    UserTypePM["ANON"] = "ANON";
    UserTypePM["CF"] = "CF";
    UserTypePM["LC"] = "LC";
    UserTypePM["MVPD_AUTHZ"] = "MVPD_AUTHZ";
})(UserTypePM || (UserTypePM = {}));
